import { render, staticRenderFns } from "./Receptions.vue?vue&type=template&id=450b4506&"
import script from "./Receptions.vue?vue&type=script&lang=js&"
export * from "./Receptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports